import {Component } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-navfooter',
  templateUrl: './navfooter.component.html',
  styleUrls: ['./navfooter.component.css']
})
export class NavfooterComponent {

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute) { }

  onClickMenu(rota) {
    this.router.navigate([rota]);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-layout/footer/navfooter/navfooter.component.ts